/*@flow*/
import * as I from 'immutable';
import type { KeyedCollection } from 'immutable';
import nested from 'lib/nested';
import * as t from 'lib/t';

type KeyPathT = string | void;
type StateT = KeyedCollection<*, *> | Object;
type FnT = (path: KeyPathT, defaultValue: any) => any;

// getIn obtains the value of state at keyPath in the container
//
// Usage:
//    getIn(store.getState)('maps.cityMap.decks')
//
// Arguments:
//  - container
export default function getIn(stateGet: () => StateT): FnT {
  if (!I.isKeyed(stateGet())) {
    throw new TypeError('[getIn] Cannot read state from container.');
  }

  return (path: KeyPathT, fallback: any) => {
    const state = stateGet();
    // When path is empty, return full state.
    if (!path) return state;

    let value;

    // Use nested, if state is not a KeyedCollection.
    if (I.Map.isMap(state)) {
      // $FlowFixMe[incompatible-call]
      value = state.getIn(path.split('.'));
    } else {
      value = nested(state, path);
    }

    return t.Nil.is(value) ? fallback : value;
  };
}
